import React from 'react';
import { Category, Company, Banner } from '../../models';
import { useClientPoints, useCompanyBranding, useUser } from '../../hooks';
import { formatIntegerNumber } from '../../lib/FormatedClientsPoints';
import CategoriesSectionRow from './CategoriesSection/CategoriesSectionRow';
import BestSellersSectionRow from './BestSellerSection/BestSellersSectionRow';

interface SectionsCatalogProps {
  sections: { allies: Company[]; category: Category }[];
}

function SectionsCatalog({ sections }: SectionsCatalogProps) {
  const [src, setSrc] = React.useState<string>(null);

  const { points } = useClientPoints();
  const [user] = useUser();
  const [companyBranding] = useCompanyBranding();
  React.useEffect(() => {
    if (!companyBranding) return;
    const bannerItem = companyBranding?.banners?.find(
      (banner: Banner) => banner.seccion === 'seccionInicio' // CAMBI
    );
    if (bannerItem) {
      setSrc(bannerItem.image);
    }
  }, [companyBranding]);
  return (
    <section className="min-h-screen flex flex-col ">
      <div className="flex relative">
        <div className="absolute flex flex-col justify-center items-center  w-full h-full text-white sm:items-start sm:mx-[6%] z-30 select-none">
          <h1 className="text-[6vw] sm:text-[3.5vw]">
            ¡Bienvenido {user?.firstName}!
          </h1>
          {points === 0 ? (
            <h2 className="text-[3vw] sm:text-[2.5vw] text-center">
              Encuentra aquí los beneficios que tenemos para ti
            </h2>
          ) : (
            <h2 className="text-[5vw] sm:text-[4.5vw]">
              Tienes {formatIntegerNumber(points)} puntos
            </h2>
          )}
        </div>
        {src !== null ? (
          // FONDO CON IMAGEN DE COMPANYBRANDING
          <>
            <div className="h-[130px] sm:h-[350px] w-full absolute top-0 left-0 z-10 bg-black bg-opacity-50" />
            <img
              src={src}
              alt="image/banner"
              className="h-[130px] sm:h-[350px] w-full object-cover object-center"
            />
          </>
        ) : (
          // FONDO MORADO
          <div className="h-[130px] sm:h-[350px] w-full bg-color-primary-300" />
        )}
      </div>
      <div className="p-10 flex flex-col space-y-10 mb-5">
        {/* Commented for now  */}
        {/* <div className="flex flex-col">
          <BestSellersSectionRow />
        </div> */}
        <div className="flex flex-col gap-10">
          {sections?.map((sectionContent) => (
            <CategoriesSectionRow
              sections={[
                {
                  category: sectionContent.category,
                  allies: sectionContent.allies,
                },
              ]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default SectionsCatalog;
